export default "$ vue create my-app\n// navigate to new project directory\n$ cd my-app\n";